import React from 'react';
import { Modifier } from '../../../lib/bemUtils/Modifier';
import bem from '../../../lib/bemUtils/bem';

export enum TextBubbleModifier {
  MARGIN_BOTTOM = 'margin-bottom',
}

type TextBubbleProps = {
  content?: string;
  type?: string;
  modifier?: Modifier<TextBubbleModifier>;
};

export default function TextBubble({ content, type, modifier }: TextBubbleProps) {
  if (!content) {
    return null;
  }

  return (
    <p className={bem('text-bubble', modifier)}>
      {type && <dfn className="invisible">{type}: </dfn>}
      <span className="text-bubble__text">&bdquo;{content}&ldquo;</span>
    </p>
  );
}
